import React, { useContext } from 'react'
import { ReactComponent as CortLogo } from './icons/cort.svg'
import { ReactComponent as EversetLogo } from './icons/everset.svg'
import { ReactComponent as CortLogoSmall } from './icons/cort-small.svg'
import { AppConfigContext } from '../../../../context/AppConfig'
import VendorLogo from '../../../VendorLogo'
import PropertyLogo from '../../../PropertyLogo'
function MobileFooter({ className = '', modelLoading = false }) {

  const { isSWApp, isEWApp, isPDApp, isAvalonApp } = useContext(AppConfigContext)

  function getLogo() {
    if (isEWApp) {
      return <EversetLogo />
    }
    if (isSWApp) {
      return <VendorLogo className="!max-h-[20px] w-auto max-w-[150px]" />
    }
    return <CortLogo />
  }

  return (
    <div className={`${className}`}>
      
      <div className="bg-white w-full flex items-center justify-between h-[56px] px-[24px]">
        {!isPDApp && !isAvalonApp && (
          <>
            <div className={`${!isEWApp ? 'pl-[16px]' : ''}`}>{getLogo()}</div>
          </>
        )}
        {isPDApp && (
          <>
            <div className={`flex items-center`}>
              {}
              <CortLogoSmall />
              <div className='mx-[16px]'>
                <PropertyLogo className='!h-auto !max-w-[86px]' />
              </div>
            </div>
          </>
        )}
        {/* <ContactUs /> */}
      </div>
    </div>
  )
}

export default MobileFooter
